import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AIListService,
  IAIListState,
  selectAIListState,
} from '@usf/ngrx-list-ai';
import { ProductStateService } from '@usf/ngrx-product';
import { filter, first, tap } from 'rxjs';
import { PATHS } from '../../shared/constants/paths';

@Injectable({
  providedIn: 'root',
})
export class AiListBuilderResolverService {
  constructor(
    private store: Store,
    private aiListService: AIListService,
    private productStateService: ProductStateService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const aiListId = route.params['aiListId'];
    return this.store.select(selectAIListState).pipe(
      filter((aiListState: IAIListState) => aiListState?.loaded),
      first(),
      tap((aiListState: IAIListState) => {
        const aiList = aiListState.entities[aiListId];
        if (!!aiList) {
          // Set aiListId
          this.aiListService.setSelectedAiListId(aiListId);
          // Extract productNumbers
          const productNumbers = []
            .concat(
              ...aiList.groups.map(group => group?.groupItems ?? []), // Flatten the arrays manually
            )
            .filter(item => item?.match?.productNumber) // Filter items that have a productNumber
            .map(item => item?.match?.productNumber);
          // Load Products from productNumbers Array
          this.productStateService.loadProductsWithRetry(productNumbers);
        } else {
          // If we try navigating to an ai list and the id doesnt exist, navigate back to list of lists
          this.router.navigate([PATHS.LISTS]);
        }
      }),
    );
  }
}
